export enum BufferEncoding {
  BASE64 = 'base64',
  BINARY = 'binary'
}
